module.exports = __webpack_public_path__ + "static/media/NO_IMAGE.edc3d2b9.png";